import * as React from "react"
const AudioFileIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={40}
    fill="none"
    {...props}
  >
    <path
      stroke="#338AFF"
      strokeWidth={2}
      d="m1.595 10.357 8.898-8.78A2 2 0 0 1 11.898 1H28a3 3 0 0 1 3 3v32a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V11.78a2 2 0 0 1 .595-1.423Z"
    />
    <path
      stroke="#338AFF"
      strokeWidth={2}
      d="M11 2v9a1 1 0 0 1-1 1H2m7 16.95v-5.9a.05.05 0 0 1 .05-.05h4.45l3.418-2.93a.05.05 0 0 1 .082.039V31.89a.05.05 0 0 1-.082.038L13.5 29H9.05a.05.05 0 0 1-.05-.05Z"
    />
    <path
      fill="#338AFF"
      d="M22.71 21.352c-.323-.222-.752-.12-.957.231-.205.35-.109.814.215 1.035 1.148.788 1.834 2.127 1.834 3.582s-.686 2.794-1.834 3.582c-.324.221-.42.685-.215 1.035.189.321.61.47.958.231 1.552-1.064 2.479-2.876 2.479-4.848s-.927-3.784-2.48-4.848Zm-1.618 2.446c-.335-.198-.757-.068-.943.295a.788.788 0 0 0 .225.987l.049.032c.373.222.605.639.605 1.088 0 .423-.206.817-.54 1.047l-.065.04c-.336.201-.458.657-.273 1.02.186.364.608.494.942.295.816-.486 1.323-1.406 1.323-2.402 0-.996-.507-1.917-1.323-2.402Z"
    />
  </svg>
)
export default AudioFileIcon
